module.exports = __webpack_public_path__ + "static/img/content4.c3aa8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/bridge/content4.png
// module id = szuN
// module chunks = 1